angular.module('impactx.configuration').service("AppConfiguration", [
    '$q',
    '$config',
    'dataGen',
    'TranslationService',
    '$rootScope',
    function AppConfiguration($q, $config, dataGen, TranslationService, $rootScope) {
        var initialized = false;
        var configurations = new Map();

        /**
         * This function sends the request which retrieves the app configuration data and stores it in a Map.
         * This request is synchronous on purpose! It's (currently) the only way to make sure this configuration service is
         * initialized before everything else happens. I set a timeout of 10 seconds just to make sure this request isn't blocking forever.
         *
         * @returns {Promise}
         */
        function initialize() {
            if (!initialized) {
                return jQuery.ajax({
                    dataType: "json",
                    timeout: 15000,
                    url: $config.sourceURL + '/appconfiguration/view',
                    success: function (result) {
                        if (result) {
                            angular.forEach(result.entries, function (value) {
                                configurations.set(value.name, value.value);
                            });
                            initialized = true;

                            var customFont = false;

                            if (get("font")) {
                                var newStyle = document.createElement('style');
                                newStyle.appendChild(document.createTextNode("@font-face {" +
                                    "    font-family: CustomFont;" +
                                    "    font-style: normal;" +
                                    "    font-weight: normal;" +
                                    "    src: url(" + $config.baseURL + "/fonts/" + get("font") + ".ttf) format(\"truetype\")," +
                                    "         url(" + $config.baseURL + "/fonts/" + get("font") + ".eot)" +
                                    "}"));
                                document.head.appendChild(newStyle);
                                customFont = true;
                            }

                            if (customFont) {
                                if (get("fontBold")) {
                                    var newStyleBold = document.createElement('style');
                                    newStyleBold.appendChild(document.createTextNode("@font-face {" +
                                        "    font-family: CustomFont;" +
                                        "    font-style: normal;" +
                                        "    font-weight: bold;" +
                                        "    src: url(" + $config.baseURL + "/fonts/" + get("fontBold") + ".ttf) format(\"truetype\")," +
                                        "         url(" + $config.baseURL + "/fonts/" + get("fontBold") + ".eot)" +
                                        "}"));
                                    document.head.appendChild(newStyleBold);
                                }

                                if (get("fontItalic")) {
                                    var newStyleItalic = document.createElement('style');
                                    newStyleItalic.appendChild(document.createTextNode("@font-face {" +
                                        "    font-family: CustomFont;" +
                                        "    font-style: italic;" +
                                        "    font-weight: normal;" +
                                        "    src: url(" + $config.baseURL + "/fonts/" + get("fontItalic") + ".ttf) format(\"truetype\")," +
                                        "         url(" + $config.baseURL + "/fonts/" + get("fontItalic") + ".eot)" +
                                        "}"));
                                    document.head.appendChild(newStyleItalic);
                                }

                                if (get("fontBoldItalic")) {
                                    var newStyleItalicBold = document.createElement('style');
                                    newStyleItalicBold.appendChild(document.createTextNode("@font-face {" +
                                        "    font-family: CustomFont;" +
                                        "    font-style: italic;" +
                                        "    font-weight: bold;" +
                                        "    src: url(" + $config.baseURL + "/fonts/" + get("fontBoldItalic") + ".ttf) format(\"truetype\")," +
                                        "         url(" + $config.baseURL + "/fonts/" + get("fontBoldItalic") + ".eot)" +
                                        "}"));
                                    document.head.appendChild(newStyleItalicBold);
                                }
                                document.body.style.fontFamily = "CustomFont, Roboto, sans-serif";

                                var newStyleOverrideFont = document.createElement('style');
                                newStyleOverrideFont.appendChild(document.createTextNode("button, html, input, select, textarea, md-chip {" +
                                    " font-family: CustomFont, 'Roboto', sans-serif;" +
                                    "}"));
                                document.head.appendChild(newStyleOverrideFont);
                            }

                            $rootScope.language = configurations.get('defaultLanguage');
                            return TranslationService.getInitialTranslations(dataGen, configurations.get('defaultLanguage'), configurations.get('defaultLanguage'));
                        }
                    },
                    error: function () {
                        return $q.when();
                    },
                    async: false
                });
            }
            return $q.when();
        }

        function get(configName) {
            if (initialized) {
                return configurations.get(configName);
            }
        }

        function isInitialized() {
            return initialized;
        }

        return {
            get: get,
            isInitialized: isInitialized,
            initialize: initialize
        };
    }]);